export default __webpack_public_path__ + "static/media/your-records-preamble.e9f964b0.md";